<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="d-sm-none">
    <div class="d-flex justify-content-between">
      <label class="col-form-label">
        {{ 'COMMON_UI.KOMMUNIKATIONSMITTEL.TELEFONNUMMER.VORWAHL_INT_NAT_RUF' | translate }}
      </label>
      <common-ui-daten-uebernahme (picked)="form.reset($event)" [itemTemplate]="datenuebernahmeTelefonnummer"
                                  [items]="stammdatenTelefonnummern" [readonly]="readonly"
                                  context="Telefonnummer{{index}}Sm"></common-ui-daten-uebernahme>
    </div>
  </div>

  <div class="form-row">
    <label class="d-none d-sm-inline col-sm-3 col-form-label" for="vorwahlInternational{{index}}">
      <span class="d-flex justify-content-between">
        <span>{{ 'COMMON_UI.KOMMUNIKATIONSMITTEL.TELEFONNUMMER.VORWAHL_INT_NAT_RUF' | translate }}</span>
      </span>
    </label>
    <div class="d-none d-sm-flex col-sm-1 common-ui-small-stammdaten-button">
      <common-ui-daten-uebernahme (picked)="form.reset($event)" [itemTemplate]="datenuebernahmeTelefonnummer"
                                  [items]="stammdatenTelefonnummern" [readonly]="readonly"
                                  context="Telefonnummer{{index}}" imageOnly="true"></common-ui-daten-uebernahme>
    </div>
    <label class="d-none"
           for="vorwahlInternational{{index}}">{{ 'COMMON_UI.KOMMUNIKATIONSMITTEL.TELEFONNUMMER.VORWAHL_INTERNATIONAL' | translate }}</label>
    <div class="col-3 col-sm-2 col-lg-2">
      <input [checkAdditionalControls]="['vorwahlNational', 'rufnummer']" class="form-control" datevMessagePath="vorwahlInternational{{objectId}}" formControlName="vorwahlInternational"
             id="vorwahlInternational{{index}}" placeholder="0049"
             type="text" utilsCheckValidity
             utilsControlState utilsValidationMessage/>
    </div>

    <label class="d-none"
           for="vorwahlNational{{index}}">{{ 'COMMON_UI.KOMMUNIKATIONSMITTEL.TELEFONNUMMER.VORWAHL_NATIONAL' | translate }}</label>
    <div class="col-4 col-sm-2 col-lg-2">
      <input [checkAdditionalControls]="['rufnummer']" class="form-control" datevMessagePath="vorwahlNational{{objectId}}"
             formControlName="vorwahlNational" id="vorwahlNational{{index}}"
             type="text" utilsCheckValidity
             utilsControlState utilsMarkRequired utilsValidationMessage/>
    </div>

    <label class="d-none"
           for="rufnummer{{index}}">{{ 'COMMON_UI.KOMMUNIKATIONSMITTEL.TELEFONNUMMER.RUFNUMMER' | translate }}</label>
    <div class="col-5 col-sm-4 position-relative">
      <input [checkAdditionalControls]="['vorwahlNational']" class="form-control" datevMessagePath="rufnummer{{objectId}}"
             formControlName="rufnummer" id="rufnummer{{index}}"
             type="text" utilsCheckValidity
             utilsControlState utilsMarkRequired utilsValidationMessage/>
      <div *ngIf="!readonly && showRemoveTelefonnummerButton" class="common-ui-telefon-remove-button">
        <button (click)="removeTelefonnummer()"
                class="btn btn-light btn-img" id="telefonnummerEntfernen{{index}}"
                type="button">
          <em class="icon icon-svg icon-fi-loeschen"></em>
        </button>
      </div>
    </div>

  </div>

</form>

<ng-template #datenuebernahmeTelefonnummer let-item="item">
  <h4 class="list-group-item-heading">{{item.vorwahlInternational}} {{item.vorwahlNational}} {{item.rufnummer}}</h4>
  <p *ngIf="item.notiz" class="list-group-item-text">{{item.notiz}}</p>
</ng-template>
